import { useState } from 'react'

export type UseBlurValidationEnabled = {
  isBlurValidationEnabled: boolean
  enableBlurValidation: () => void
  disableBlurValidation: () => void
}

// Without this guard hook, when a field is on focus and the submit button is
// clicked, the onBlur validation may cause the height of the form to
// change, making it so that the click lands outside of the submit button!
// This is an issue in DGC forms at the time of this writing.
// todo(jcejudo): create ticket for above scenario and link to it
const useBlurValidation = (): UseBlurValidationEnabled => {
  const [isEnabled, setEnabled] = useState(true)

  const enableBlurValidation = () => setEnabled(true)
  const disableBlurValidation = () => setEnabled(false)

  return {
    isBlurValidationEnabled: isEnabled,
    enableBlurValidation,
    disableBlurValidation,
  }
}

export default useBlurValidation
